/**
 * Posting to event should look like this:
 * .post({
 *      event: {
 *          request_id - String (from get request),
 *          event_id - String (create own),
 *          parent_event_id (no backend support),
 *          create_time - Timestamp,
 *          extra_info - map<string, string>
 *      }
 * })
 */

export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        '',
        data => ({
            id: 1,
        }),
    ],

    POST: {},
};
